export const env = {
    env: 'prod'

  };
